import BullBuyCall from "../images/prebuild_graphs/bullish/buy call1.svg";
import BullSellPut from "../images/prebuild_graphs/bullish/sell put1.svg";
import BullBullCallSpread from "../images/prebuild_graphs/bullish/Bull Call Spread.svg";
import BullBullPutSpread from "../images/prebuild_graphs/bullish/Bull put Spread.svg";
import BullBullButterfly from "../images/prebuild_graphs/bullish/bull_butterfly.svg";
import BullBullCondor from "../images/prebuild_graphs/bullish/bull_condor.svg";
import BullLongCalenderWithCalls from "../images/prebuild_graphs/bullish/long_calendar_calls.svg";
import BullCallRatioBackSpread from "../images/prebuild_graphs/bullish/Call ratio back spread.svg";

// Bearish imports
import BearBuyPut from "../images/prebuild_graphs/bearish/buy put.svg";
import BearSellCall from "../images/prebuild_graphs/bearish/sell call.svg";
import BearPutSpeard from "../images/prebuild_graphs/bearish/bear put Spread.svg";
import BearCallSpeard from "../images/prebuild_graphs/bearish/bear Call Spread.svg";
import BearButterfly from "../images/prebuild_graphs/bearish/bear_butterfly.svg";
import BearCondor from "../images/prebuild_graphs/bearish/bear_condor.svg";
import BearLongCalendarWithPuts from "../images/prebuild_graphs/bearish/long_calendar_puts.svg";
import BearPutRationBackSpread from "../images/prebuild_graphs/bearish/put ratio back spread.svg";

//neutral imports
import NeuShortStraddle from "../images/prebuild_graphs/neutral/short straddle.svg";
import NeuShortStrangle from "../images/prebuild_graphs/neutral/short strangle.svg";
import NeuIronButterfly from "../images/prebuild_graphs/neutral/iron_butterfy.svg";
import NeuIronCondor from "../images/prebuild_graphs/neutral/iron condor.svg";
import NeuBatman from "../images/prebuild_graphs/neutral/batman.svg";
import NeuDoublePlateau from "../images/prebuild_graphs/neutral/double plateau.svg";
import NeuJadeLizard from "../images/prebuild_graphs/neutral/jade lizard.svg";
import NeuReverseJadeLizard from "../images/prebuild_graphs/neutral/Reverse jade lizard.svg";

export const strategies = {
  bullish: [
    {
      id: "buy_call",
      name: "Buy Call",
      image: BullBuyCall,
      risk: "Low",
      hedged: true,
      isNew: false,
    },
    {
      id: "sell_put",
      name: "Sell Put",
      image: BullSellPut,
      risk: "High",
      hedged: false,
      isNew: false,
    },
    {
      id: "bull_call_spread",
      name: "Bull Call Spread",
      image: BullBullCallSpread,
      risk: "Medium",
      hedged: true,
      isNew: false,
    },
    {
      id: "bull_put_spread",
      name: "Bull Put Spread",
      image: BullBullPutSpread,
      risk: "Medium",
      hedged: true,
      isNew: false,
    },
    {
      id: "bull_butterfly",
      name: "Bull Butterfly",
      image: BullBullButterfly,
      risk: "Medium",
      hedged: true,
      isNew: true,
    },
    {
      id: "bull_condor",
      name: "Bull Condor",
      image: BullBullCondor,
      risk: "Medium",
      hedged: true,
      isNew: true,
    },
    {
      id: "long_calendar_calls",
      name: "Long calendar with calls",
      image: BullLongCalenderWithCalls,
      risk: "Medium",
      hedged: true,
      isNew: true,
    },
    {
      id: "call_ratio_back_spread",
      name: "Call Ratio Back Spread",
      image: BullCallRatioBackSpread,
      risk: "Medium",
      hedged: true,
      isNew: false,
    },
  ],

  bearish: [
    {
      id: "buy_put",
      name: "Buy Put",
      image: BearBuyPut,
      risk: "Low",
      hedged: true,
      isNew: false,
    },
    {
      id: "sell_call",
      name: "Sell Call",
      image: BearSellCall,
      risk: "High",
      hedged: false,
      isNew: false,
    },
    {
      id: "bear_put_spread",
      name: "Bear Put Spread",
      image: BearPutSpeard,
      risk: "Medium",
      hedged: true,
      isNew: false,
    },
    {
      id: "bear_call_spread",
      name: "Bear Call Spread",
      image: BearCallSpeard,
      risk: "Medium",
      hedged: true,
      isNew: false,
    },
    {
      id: "bear_butterfly",
      name: "Bear Butterfly",
      image: BearButterfly,
      risk: "Medium",
      hedged: true,
      isNew: true,
    },
    {
      id: "bear_condor",
      name: "Bear Condor",
      image: BearCondor,
      risk: "Medium",
      hedged: true,
      isNew: true,
    },
    {
      id: "long_calendar_puts",
      name: "Long calendar with puts",
      image: BearLongCalendarWithPuts,
      risk: "Medium",
      hedged: true,
      isNew: true,
    },
    {
      id: "put_ratio_back_spread",
      name: "Put Ratio Back Spread",
      image: BearPutRationBackSpread,
      risk: "Medium",
      hedged: true,
      isNew: false,
    },
  ],
  neutral: [
    {
      id: "short_straddle",
      name: "Short Straddle",
      image: NeuShortStraddle,
      risk: "High",
      hedged: false,
      isNew: false,
    },
    {
      id: "short_strangle",
      name: "Short Strangle",
      image: NeuShortStrangle,
      risk: "High",
      hedged: false,
      isNew: false,
    },
    {
      id: "iron_butterfly",
      name: "Iron Butterfly",
      image: NeuIronButterfly,
      risk: "Medium",
      hedged: true,
      isNew: false,
    },
    {
      id: "iron_condor",
      name: "Iron Condor",
      image: NeuIronCondor,
      risk: "Medium",
      hedged: true,
      isNew: false,
    },
    {
      id: "batman",
      name: "Batman",
      image: NeuBatman,
      risk: "Medium",
      hedged: true,
      isNew: true,
    },
    {
      id: "double_plateau",
      name: "Double Plateau",
      image: NeuDoublePlateau,
      risk: "Medium",
      hedged: true,
      isNew: true,
    },
    {
      id: "jade_lizard",
      name: "Jade Lizard",
      image: NeuJadeLizard,
      risk: "Medium",
      hedged: true,
      isNew: true,
    },
    {
      id: "reverse_jade_lizard",
      name: "Reverse Jade Lizard",
      image: NeuReverseJadeLizard,
      risk: "Medium",
      hedged: true,
      isNew: true,
    },
  ],
  saved:[]
};
